import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl
} from "@mui/material";
import { AiOutlineSearch } from "react-icons/ai";
import { makeStyles } from "@mui/styles";

import Layout from "../../components/Wrappers/Layout";
import SearchIcon from "@mui/icons-material/Search";
import {
	Card,
	Alert,
	Row,
	Col,
	CardTitle,
	CardHeader,
	FormGroup
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../components/CustomButton/CustomButton";
import { getBusinessNatureList } from "../../redux/actions/getBusinessNatureListAction";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getWalletOwnerIdAndNameListApi } from "../../redux/actions/getWalletOwnerIdAndNameListApiAction";
import { getBusinessNatureMappingList } from "../../redux/actions/getBusinessNatureMappingListAction";
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import BackButton from "../../components/BackButton/BackButton";
import val from "../../getThemeDetails"

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminWalletOwnerSettings = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [walletOwnerTableArray, setWalletOwnerTableArray] = useState([]);
	const [walletOwnerTableStatus, setWalletOwnerTableStatus] = useState(false);
	const [walletOwnerArray, setWalletOwnerArray] = useState([]);
	const [walletOwnerStatus, setWalletOwnerStatus] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [pageToggle, setPageToggle] = useState(false);
	const navigate = useHistory();
	const [walletOwner, setWalletOwner] = useState("");
	console.log(walletOwner, "walletOwner");

	const classes = useStyles();

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getOwnerAndNameList = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const getOwnerAndNameListApi = useSelector(
		({ getWalletOwnerAndNameListApi }) => getWalletOwnerAndNameListApi
	);

	const getWalletOwnerIdAndNameListTableRequest = () => {
		// setIsLoading(true);
		setWalletOwnerTableStatus(true);
		const getWalletOwnerIdAndNameListReq = {
			loginDetails: {
				// adminId: 2
				adminId: val.adminIDS

			}
		};
		dispatch(
			getWalletOwnerIdAndNameList(getWalletOwnerIdAndNameListReq, authToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWalletOwnerIdAndNameListTableRequest();
			getWalletOwnerIdAndNameListApiReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	// const searchHandleAPI = () => {
	//   getWalletOwnerIdAndNameListRequest();
	//   console.log(searchHandleAPI);
	//   // console.log(BusinessNatureMappingList, 'BusinessNatureMappingList');
	// };

	const getWalletOwnerListResFunc = () => {
		if (walletOwnerTableStatus) {
			if (getOwnerAndNameList.data.status == "success") {
				// setIsLoading(false);
				setWalletOwnerTableArray([].concat(getOwnerAndNameList.data.ownerList));
			}
			if (getOwnerAndNameList.data.status === "failed") {
				// setIsLoading(false);
				setWalletOwnerTableArray(getOwnerAndNameList.data.ownerList);
				if (
					getOwnerAndNameList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getOwnerAndNameList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getWalletOwnerListResFunc();
	}, [getOwnerAndNameList.data.status]);

	const getWalletOwnerIdAndNameListApiReq = () => {
		setIsLoading(true);
		setWalletOwnerStatus(true);
		const getWalletOwnerIdAndNameListReq = {
			loginDetails: {
				// adminId: 2,
				adminId: val.adminIDS,
				
				walletOwnerId: walletOwner.split("-")[0]
			}
		};
		dispatch(
			getWalletOwnerIdAndNameListApi(getWalletOwnerIdAndNameListReq, authToken)
		);
	};

	const getWalletOwnerListApiResFunc = () => {
		if (walletOwnerStatus) {
			if (getOwnerAndNameListApi.data.status == "success") {
				setIsLoading(false);
				setWalletOwnerArray([].concat(getOwnerAndNameListApi.data.ownerList));
			}
			if (getOwnerAndNameListApi.data.status === "failed") {
				setIsLoading(false);
				setWalletOwnerArray(getOwnerAndNameListApi.data.ownerList);
				if (
					getOwnerAndNameListApi.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getOwnerAndNameListApi.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getWalletOwnerListApiResFunc();
	}, [getOwnerAndNameListApi.data.status]);

	// Pagination
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const viewHandleClickOpen = () => {
		setViewOpen(true);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "walletOwner") {
			setWalletOwner(value == "Select Owner ID" ? "" : value);
		}
	};

	const sendWalletOwnerView = (id, name) => {
		setPageToggle(true);
		navigate.push({
			pathname: `/index/wallet-owner-settings-view`,
			state: { name: `${name}` },
			search: `?userId=${id}`
		});
	};

	const sendWalletOwnerEdit = (id, datas) => {
		setPageToggle(true);
		navigate.push({
			pathname: `/index/wallet-owner-settings-update`,
			search: `?userId=${id}`
		});
	};

	const sendModuleAllocation = (id, datas) => {
		setPageToggle(true);
		navigate.push({
			pathname: `/index/adminModuleAllocation`,
			search: `?userId=${id}`
		});
	};

	return (
		<Layout>
			<BackButton />
			<Card>
				<Grid
					container
					style={{ padding: "15px", justifyContent: "right" }}
					spacing={2}
				>
					<Grid item md={2} sm={12} xs={12} lg={3}>
						<NavLink to="/index/adminAddModule">
							<CustomButton
								style={{
									padding: "8px"
								}}


							>
								Add Module
							</CustomButton>
							{/* <Button
								size="small"
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									margin: '0 auto',
									display: 'block',
									width: 'max-content'
								}}
								variant="contained"
								className="riskRuleButton"
							>
								Add Module
							</Button> */}
						</NavLink>
					</Grid>
					<Grid item md={2} sm={12} xs={12} lg={3}>
						<NavLink to="/index/loyalty-management">
							<CustomButton
								style={{
									padding: "8px"
								}}


							>
								Loyalty Point Management
							</CustomButton>

							{/* <Button
								size="small"
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								className="riskRuleButton"
							>
								Loyalty Point Management
							</Button> */}
						</NavLink>
					</Grid>
				</Grid>

				<Grid
					container
					spacing={2}
					style={{ padding: "25px", marginTop: "2rem" }}
				>
					<Grid item sm={12} md={4} lg={4}>
						<TextField
							select
							autoFocus
							margin="dense"
							id="name"
							label="Owner ID"
							type="name"
							fullWidth
							variant="standard"
							name="walletOwner"
							onChange={handleChange}
							// value={walletOwner || "Select Owner ID"}
							defaultValue={"Select Owner ID" || walletOwner}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="Select Owner ID" selected="Select Owner ID">
								Select Owner ID
							</MenuItem>
							{getOwnerAndNameList.data.ownerList &&
								getOwnerAndNameList.data.ownerList &&
								[]
									.concat(getOwnerAndNameList.data.ownerList)
									.map((dropdown) => (
										<MenuItem value={dropdown}>{dropdown}</MenuItem>
									))}
						</TextField>
					</Grid>
					<Grid item sm={12} md={4} lg={4}>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={getWalletOwnerIdAndNameListApiReq}


						>
							Search <SearchIcon />
						</CustomButton>
						{/* <Button
							style={{
								marginLeft: "0.7rem",
								backgroundColor: "#00b9f5",
								color: "white",
								marginTop: "17px"
							}}
							endIcon={<AiOutlineSearch />}
							variant="contained"
							onClick={getWalletOwnerIdAndNameListApiReq}
						>
							Search
						</Button> */}
					</Grid>
				</Grid>
				{/*  */}
			</Card>

			{/* <Card > */}

			{isLoading ? (
				<LoadingSpinner />
			) : walletOwnerArray.length == undefined || !walletOwnerStatus ? (
				<Card>
					<Grid
						container
						style={{
							padding: "10px"
						}}
					>
						<Grid xs={12} sm={12} md={12} lg={12}>
							<Typography variant="body1" style={{ fontWeight: "700" }}
								className="themeText"
							>
								Owner Setting Details
							</Typography>
						</Grid>

						<Grid xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="my-3 tableHeaderColor"
								variant="secondary"
							// style={{ backgroundColor: "#00b9f5", color: "white" }}
							>
								No Records Found!
							</Alert>
						</Grid>
					</Grid>
				</Card>
			) : (
				<Card>
					<Grid
						container
						style={{
							padding: "10px"
						}}
					>
						<Grid xs={12} sm={12} md={12} lg={12}>
							<Typography variant="body1" style={{ fontWeight: "700" }}
								className="themeText"
							>
								Owner Setting Details
							</Typography>
						</Grid>
						<TableContainer component={Paper} className="my-3">
							<Table
								className={classes.table}
								size="small"
								aria-label="a dense table"
							>
								<TableHead>
									<TableRow className="tableHeaderColor">

										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Owner ID
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Owner Name
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Action
										</TableCell>
										{/* <TableCell
                  align="center"
                  style={{ fontWeight: "bold", color: "white" }}
                >
                  Update
                </TableCell> */}
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Module Allocation
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{walletOwnerArray &&
										[]
											.concat(walletOwnerArray)
											.slice(
												page * rowsPerPage,
												page * rowsPerPage + rowsPerPage
											)
											.map((row, index) => (
												<TableRow key={index}>
													<TableCell align="center">
														{row.split("-")[0]}
													</TableCell>
													<TableCell align="center">
														{row.split("-")[1]}
													</TableCell>
													<TableCell align="center">
														<CustomButton
															align="center"
															style={{
																padding: "8px",
																margin: "0 8px"
															}}
															onClick={() =>
																sendWalletOwnerView(
																	row.split("-")[0],
																	row.split("-")[1]
																)
															}
														>
															{
																<VisibilityIcon
																	style={{
																		color: "#fff",
																		fontSize: "20px"
																	}}
																/>
															}
														</CustomButton>
														<CustomButton
															style={{
																padding: "8px"
															}}
															onClick={() =>
																sendWalletOwnerEdit(
																	row.split("-")[0],
																	row.split("-")[1]
																)
															}
														>
															{
																<EditIcon
																	style={{
																		color: "#fff",
																		fontSize: "20px"
																	}}
																/>
															}
														</CustomButton>
													</TableCell>
													{/* <TableCell align="center">
                        <CustomButton
                          style={{
                            padding: "8px",
                          }}
                          onClick={() =>
                            sendWalletOwnerEdit(
                              row.split("-")[0],
                              row.split("-")[1]
                            )
                          }
                        >
                          {
                            <EditIcon
                              style={{
                                color: "#fff",
                                fontSize: "20px",
                              }}
                            />
                          }
                        </CustomButton>
                      </TableCell> */}
													<TableCell align="center">
														{/* <NavLink to="/index/adminModuleAllocation"> */}
														<CustomButton
															style={{
																padding: "8px"
															}}
															onClick={() =>
																sendModuleAllocation(
																	row.split("-")[0],
																	row.split("-")[1]
																)
															}
														>
															Module Allocation
														</CustomButton>
														{/* </NavLink> */}
													</TableCell>
												</TableRow>
											))}
								</TableBody>
							</Table>
							{/* <TablePagination
								rowsPerPageOptions={[5, 10, 25]}
								component="div"
								count={walletOwnerTableArray.length}
								rowsPerPage={rowsPerPage}
								page={page}
								onPageChange={handleChangePage}
								onRowsPerPageChange={handleChangeRowsPerPage}
							/> */}
							<TablePagination
								rowsPerPageOptions={[5, 10, 25]}
								component="div"
								count={walletOwnerTableArray ? walletOwnerTableArray.length : 0}
								rowsPerPage={rowsPerPage}
								page={page}
								onPageChange={handleChangePage}
								onRowsPerPageChange={handleChangeRowsPerPage}
							/>
						</TableContainer>
					</Grid>
				</Card>
			)}
		</Layout>
	);
};

export default AdminWalletOwnerSettings;
